import { QUERY_PARAMETERS, SEARCH_PARAMS } from "common/constants"
import moment from "moment"
import * as ROUTES from "routes/RoutePaths"
import notification from "./notification"

export const initialQueryState = {
  sortingCriteria: {
    sort: "",
    property: "",
  },
  maxResult: 10,
  skipCount: 0,
  isEnabled: true,
  params: "",
}

export const isSortingCriteriaEmpty = (sortingCriteria: $TSMigrationFixMe) =>
  Boolean(sortingCriteria?.property && sortingCriteria?.sort)

/**
 * Utilidad que genera una cadena de consulta para un endpoint con parámetros recibidos.
 *
 * @param {string} endpoint - El endpoint base al que se agregarán los parámetros de consulta.
 * @param {Object} [queryState=initialQueryState] - Objeto que contiene los parámetros de consulta. Por defecto, se utiliza `initialQueryState`.
 * @returns {string} - Cadena de consulta generada.
 */
export const queryFixer = (
  endpoint: $TSMigrationFixMe,
  queryState = initialQueryState
) => {
  if (!Object.keys(queryState).length) return `${endpoint}`
  return `${endpoint ? `${endpoint}` : ""}${
    !endpoint.includes("?") ? "?" : "&"
  }${queryState.maxResult ? `&MaxResultCount=${queryState.maxResult}` : ""}${
    queryState.skipCount ? `&SkipCount=${queryState.skipCount}` : ""
    // @ts-expect-error TS(2339): Property 'razonSocial' does not exist on type '{ s...
  }${queryState.razonSocial ? `&RazonSocial=${queryState.razonSocial}` : ""}${
    queryState.sortingCriteria?.property
      ? `&SortingCriteria=${queryState.sortingCriteria?.property}%20${queryState.sortingCriteria?.sort}`
      : "&SortingCriteria=CreationTime%20DESC"
    // @ts-expect-error TS(2339): Property 'nombre' does not exist on type '{ sortin...
  }${queryState?.nombre ? `&nombre=${queryState?.nombre}` : ""}
  ${queryState.params && `${queryState.params}`}${
    // @ts-expect-error TS(2339): Property 'keyword' does not exist on type '{ sorti...
    queryState.keyword ? `&Keyword=${queryState.keyword}` : ""
  } `
}

export const normalizeString = (str = "") => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

export const fileToBase64 = (file: $TSMigrationFixMe) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

export const toAlphaNumerics = (str = "") =>
  str.replace(/[^a-z 0-9]/gi, "").replaceAll(" ", "")

export const arrayEquals = (a: $TSMigrationFixMe, b: $TSMigrationFixMe) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  )
}

const DEBOUNCE_DELAY_TIME = 200
export const debounce = (
  func: $TSMigrationFixMe,
  timeout = DEBOUNCE_DELAY_TIME
) => {
  let timer: $TSMigrationFixMe
  return (...args: $TSMigrationFixMe[]) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func(...args)
    }, timeout)
  }
}

export const getTextFilterValues = (parameters: $TSMigrationFixMe) => {
  return (
    Object.entries(parameters)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .map(([_, value]) => {
        // @ts-expect-error TS(2571): Object is of type 'unknown'.
        return value.currentValue
      })
      .join("")
  )
}

export const getInitialPaginationQuery = (pagination: $TSMigrationFixMe) => {
  return `${QUERY_PARAMETERS.MaxResultCount}=${
    pagination ? pagination.rows : initialQueryState.maxResult
  }${QUERY_PARAMETERS.SkipCount}=${
    pagination ? pagination.first : initialQueryState.skipCount
  }`
}
export const truncateString = ({ str, maxLength = 18 }: $TSMigrationFixMe) =>
  `${str?.substring(0, maxLength)}${str?.length > maxLength ? "..." : ""}`

export const initialPaginationQuery = `${QUERY_PARAMETERS.MaxResultCount}=${initialQueryState.maxResult}${QUERY_PARAMETERS.SkipCount}=${initialQueryState.skipCount}`
export const dinamicPaginationQuery = `${QUERY_PARAMETERS.MaxResultCount}=${initialQueryState.maxResult}${QUERY_PARAMETERS.SkipCount}=`

export const requestHandler = async (
  values: $TSMigrationFixMe,
  asyncCallback: $TSMigrationFixMe,
  onPostSuccess: $TSMigrationFixMe,
  onSuccessMessage: $TSMigrationFixMe,
  onFailMessage: $TSMigrationFixMe,
  onPostFailure: $TSMigrationFixMe,
  onPostRequest: $TSMigrationFixMe
) => {
  try {
    const { data: response } = await asyncCallback(values)
    onPostSuccess(values, response)
    notification.success({
      body: onSuccessMessage,
    })
  } catch (er) {
    if (onFailMessage) {
      notification.warning({
        body: onFailMessage,
      })
    }
    onPostFailure && onPostFailure(er)
  }
  onPostRequest && onPostRequest()
}

export const extractFilename = (contentDisposition: $TSMigrationFixMe) => {
  const match = contentDisposition.match(/filename\*?=(UTF-8['']|")(.*?)(;|$)/i)
  const fileName = match ? match[2] : null
  const fileNameWithoutQuotes = fileName
    ? fileName.replace(/^['"]+|['"]+$/g, "")
    : null
  return fileNameWithoutQuotes
}

export const queryCreator = (selectedOptions: $TSMigrationFixMe) =>
  selectedOptions?.map((option: $TSMigrationFixMe) => option.query).join("")

export const removeFromArray = (
  params: $TSMigrationFixMe,
  array: $TSMigrationFixMe
) => {
  let newArray = []
  if (Array.isArray(params)) {
    newArray = array.filter(
      (option: $TSMigrationFixMe) => !params.includes(option.key)
    )
  } else {
    newArray = array.filter(
      (option: $TSMigrationFixMe) => option.key !== params
    )
  }
  return newArray
}

export const checkAndSetFooterDate = (
  date: $TSMigrationFixMe,
  setFooterDate: $TSMigrationFixMe
) => {
  if (!date || date?.includes("Invalid date")) {
    setFooterDate(null)
  } else {
    setFooterDate(date)
  }
}

export const convertDateFromLocaleToUtc = (
  date: $TSMigrationFixMe,
  format: $TSMigrationFixMe
) => moment.utc(moment(date)).format(format)

export const formatDate = (
  date: $TSMigrationFixMe,
  format: $TSMigrationFixMe
) => moment(moment(date)).format(format)

export const convertDateFromUtcToLocale = (date: $TSMigrationFixMe) =>
  moment.utc(date).toDate()

export const START_YEAR_DATE = moment().startOf("year")

export const START_MONTH_DATE = moment().startOf("month")

export const CURRENT_DATE = moment(Date.now())

export const YEAR_LAST_DATE = moment().endOf("year")

export const getInidiatlDateQuery = (
  startDateQuery: $TSMigrationFixMe,
  endDateQuery: $TSMigrationFixMe
) => {
  return `${startDateQuery}=${START_YEAR_DATE.format(
    "YYYY-MM-DD"
  )}${endDateQuery}=${CURRENT_DATE.format("YYYY-MM-DD")}`
}

export const getInitDateQueryThisMonth = (
  startDateQuery: $TSMigrationFixMe,
  endDateQuery: $TSMigrationFixMe
) => {
  return `${startDateQuery}=${START_MONTH_DATE.format(
    "YYYY-MM-DD"
  )}${endDateQuery}=${CURRENT_DATE.format("YYYY-MM-DD")}`
}

export const getInitialCuentaContableIdLibroMayor = (
  cuentaId: $TSMigrationFixMe
) => {
  return `${QUERY_PARAMETERS.CuentaContableId}=${cuentaId}`
}

export const getSearchParams = (
  location: $TSMigrationFixMe,
  param: $TSMigrationFixMe
) => {
  const params = new URLSearchParams(location.search)
  return params.get(param)
}

export const OpenModalfromDirectAccess = (
  location: $TSMigrationFixMe,
  urlParam: $TSMigrationFixMe,
  openModal: $TSMigrationFixMe
) => {
  const param = getSearchParams(location, SEARCH_PARAMS.GOTO)
  // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
  const isCreateDirectAccess = param === SEARCH_PARAMS[urlParam]

  if (isCreateDirectAccess) openModal(true)
}

export const getUniqueListBy = (
  arr: $TSMigrationFixMe,
  key: $TSMigrationFixMe
) => {
  return [
    ...new Map(
      arr.map((item: $TSMigrationFixMe) => [item[key], item])
    ).values(),
  ]
}

export const infiniteScrollHandler = (
  scrollEvent: $TSMigrationFixMe,
  skipCount: $TSMigrationFixMe,
  // @ts-expect-error TS(6133): 'maxResultCount' is declared but its value is neve...
  maxResultCount: $TSMigrationFixMe,
  totalCount: $TSMigrationFixMe,
  getMore: $TSMigrationFixMe
) => {
  const isContainerEnd =
    scrollEvent.target.scrollHeight - scrollEvent.target.scrollTop <=
    scrollEvent.target.clientHeight + 6
  const hasMore = skipCount < totalCount

  if (isContainerEnd && hasMore) {
    getMore()
  }
}

export const isExpansionLoan = ({
  tipo,
  asientoContable,
}: $TSMigrationFixMe) => {
  return Boolean((tipo === 2 || tipo === 3) && !asientoContable)
}

export const isAnnotation = (rowData: $TSMigrationFixMe) => {
  return Boolean(rowData.id || rowData.asientoContable)
}

export const sortArrayByNumber = (array = []) =>
  // @ts-expect-error TS(2339): Property 'numero' does not exist on type 'never'.
  array.sort((a, b) => parseFloat(a.numero) - parseFloat(b.numero))

export const removeItemsWithEmptyQuery = (array: $TSMigrationFixMe) => {
  const filteredArray = array?.filter((item: $TSMigrationFixMe) => {
    return item?.query != null && item?.query !== ""
  })
  return filteredArray
}

export const checkArrayLengthWithoutTipoPrestamo = (
  array = [],
  pathname: $TSMigrationFixMe
) => {
  const excludedKeys = [
    "&TipoPrestamo",
    "&FechaInicioAsiento",
    "&FechaInicioMovimiento",
    "&CuentaContableId",
    "&FechaLowerLimit",
  ]
  const excludedQueries = ["=false", "&Tipo=4"]

  const regex = new RegExp(`^${ROUTES.PRESTAMOS_DETAIL.replace(":id", ".+")}$`)
  if (regex.test(pathname)) {
    return true
  }

  if (
    [
      ROUTES.CONTABILIDAD_BALANCE,
      ROUTES.CONTABILIDAD_PERDIDAS_GANANCIAS,
      ROUTES.CONTABILIDAD_SUMAS_SALDOS,
    ].includes(pathname)
  ) {
    const newArray = array?.filter((obj) =>
      // @ts-expect-error TS(2339): Property 'query' does not exist on type 'never'.
      obj.query.includes("&FechaInicioMovimiento")
    )
    return array === newArray
  }

  const filteredArray = array?.filter((item) => {
    const { key = "", query = "" } = item || {}
    return (
      !excludedQueries.some((excludedQuery) => query.includes(excludedQuery)) &&
      query !== "" &&
      !excludedKeys.includes(key)
    )
  })

  return (
    (filteredArray?.length > 0 &&
      (pathname === "/contabilidad/cuentas-contables" ||
        filteredArray?.length >= 1)) ||
    (pathname === "/validaciones" && filteredArray?.length > 0)
  )
}
